const CHANGE_FILTERS = 'realhub/admin/userFilters/CHANGE_FILTERS'

// Initial State
const initialState = {
  filterBrandId: 'all',
  filterCompanyId: '',
  filterCompanyType: '',
  filterRoleId: 'all',
  filterString: '',
}

// Actions
export function changeFilters(filters = {}){
  return {
    type: CHANGE_FILTERS,
    filters,
  }
}

// Reducer
export default function reducer(state = initialState, action = {}){
  const { type } = action

  switch (type){
    case CHANGE_FILTERS:
      return {
        ...state,
        ...action.filters,
      }
    default:
      return state
  }
}
